/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_IntelligenceInputs */

const en_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quiet Intelligence`)
};

const es_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligencia silenciosa`)
};

const fr_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligence Silencieuse`)
};

const de_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quiet Intelligence`)
};

const ja_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`静かなインテリジェンス`)
};

const zh_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐形智能 (Quiet Intelligence)`)
};

const ar_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الذكاء الهادئ`)
};

const id_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecerdasan Senyap`)
};

const it_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligenza Silenziosa`)
};

const ru_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невидимый интеллект`)
};

const pt_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligência Silenciosa`)
};

const ko_quiet_intelligence = /** @type {(inputs: Quiet_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`조용한 인텔리전스 (Quiet Intelligence)`)
};

/**
* | output |
* | --- |
* | "Quiet Intelligence" |
*
* @param {Quiet_IntelligenceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const quiet_intelligence = /** @type {((inputs?: Quiet_IntelligenceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_IntelligenceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_intelligence(inputs)
	if (locale === "es") return es_quiet_intelligence(inputs)
	if (locale === "fr") return fr_quiet_intelligence(inputs)
	if (locale === "de") return de_quiet_intelligence(inputs)
	if (locale === "ja") return ja_quiet_intelligence(inputs)
	if (locale === "zh") return zh_quiet_intelligence(inputs)
	if (locale === "ar") return ar_quiet_intelligence(inputs)
	if (locale === "id") return id_quiet_intelligence(inputs)
	if (locale === "it") return it_quiet_intelligence(inputs)
	if (locale === "ru") return ru_quiet_intelligence(inputs)
	if (locale === "pt") return pt_quiet_intelligence(inputs)
	return ko_quiet_intelligence(inputs)
});